




import VueOptions from '@utils/VueOptions'
import EventShow from '@superComponents/Event/EventShow'

settings = 
  name: "EventShowPage"
  components: { EventShow }
  vue:
    mounted: -> @$router.push({ params: { tab: 'super' }}) unless @$route.params.tab?

export default VueOptions.vue settings
